var generateStyle = function generateStyle(componentTheme) {
  return {
    choiceWrapper: {
      marginTop: componentTheme.choiceWrapperMargin
    },
    noResponseWrapper: {
      marginTop: componentTheme.noResponseWrapperMargin
    }
  };
};
export default generateStyle;